import { fmtDateShort } from "@/lib/format";

const dotColor = (label) => {
  if (label.includes("Closure")) return "#32D74B";
  if (label.includes("Proposal")) return "#FF9F0A";
  if (label.includes("Meeting")) return "#0A84FF";
  if (label.includes("Pitch")) return "#5E5CE6";
  return "#737373";
};

export const TimelinePanel = ({ timelines = [], cycleTimes = {} }) => {
  const withEvents = timelines.filter((t) => t.events && t.events.length > 0);

  return (
    <div className="space-y-4" data-testid="timeline-panel">
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-[#141414] border border-[#262626] rounded-sm p-5">
          <div className="kpi-label">Avg Cycle · Pitch → Proposal</div>
          <div className="font-mono-data text-2xl text-white mt-1">
            {cycleTimes.avg_pitch_to_proposal_days != null ? `${cycleTimes.avg_pitch_to_proposal_days} days` : "—"}
          </div>
        </div>
        <div className="bg-[#141414] border border-[#262626] rounded-sm p-5">
          <div className="kpi-label">Avg Cycle · Proposal → Closure</div>
          <div className="font-mono-data text-2xl text-white mt-1">
            {cycleTimes.avg_proposal_to_closure_days != null ? `${cycleTimes.avg_proposal_to_closure_days} days` : "—"}
          </div>
        </div>
      </div>

      {withEvents.length === 0 ? (
        <div className="border border-dashed border-[#262626] rounded-sm p-8 text-center text-sm text-[#A3A3A3]">
          No dated activities yet — add pitch/meeting/proposal dates to see the timeline.
        </div>
      ) : (
        <div className="border border-[#262626] rounded-sm divide-y divide-[#262626]">
          {withEvents.map((t, idx) => (
            <div key={t.id} className="p-4" data-testid={`timeline-row-${idx}`}>
              <div className="flex items-baseline justify-between mb-3">
                <div className="text-white font-display tracking-tight">{t.account_name}</div>
                <div className="kpi-label">{t.bdr_name}</div>
              </div>
              <div className="relative pl-2">
                <div className="absolute left-[5px] top-1 bottom-1 w-px bg-[#262626]"/>
                <div className="flex flex-wrap gap-x-8 gap-y-3">
                  {t.events.map((e, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <span className="w-2.5 h-2.5 rounded-full" style={{ background: dotColor(e.label) }}/>
                      <div>
                        <div className="text-xs text-[#A3A3A3] font-mono-data uppercase tracking-wider">{e.label}</div>
                        <div className="text-sm text-white font-mono-data">{fmtDateShort(e.date)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TimelinePanel;
